import React from "react";
import { XCircle, Home, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const PaymentCancelledPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4" data-testid="payment-cancelled-page">
      <div className="w-full max-w-md text-center">
        <div className="space-y-6">
          <div className="w-20 h-20 mx-auto bg-yellow-500/20 rounded-full flex items-center justify-center">
            <XCircle className="w-10 h-10 text-yellow-500" />
          </div>
          <h1 className="font-bebas text-3xl text-white tracking-wider">PAYMENT CANCELLED</h1>
          <p className="text-[#A1A1AA] font-ubuntu">
            Your payment was cancelled. No charges were made to your account.
          </p>
          
          <div className="bg-[#1A1A1A] border border-[#7a6200]/30 rounded-xl p-6 mt-6">
            <p className="text-[#A1A1AA] text-sm font-ubuntu">
              If you experienced any issues during checkout, please try again or contact our support team for assistance.
            </p>
          </div>
          
          <div className="flex gap-3 mt-8">
            <Button
              onClick={() => navigate("/home")}
              variant="outline"
              className="flex-1 border-[#7a6200]/30 text-[#A1A1AA] hover:bg-[#7a6200]/10"
            >
              <Home className="w-4 h-4 mr-2" />
              Home
            </Button>
            <Button
              onClick={() => navigate(-1)}
              className="flex-1 btn-gold"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Try Again
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelledPage;
